import '@aws-amplify/ui-react/styles.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@agrotoken-tech/ui';
import '@agrotoken-tech/ui/dist/assets/index.css';
import AppRoutes from './routes/Routes';
import { TranslationsProvider } from '@bcba/react-hooks';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { useHandleApiError } from '@bcba/frontend-utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function App() {
  const { handleApiError } = useHandleApiError();

  const queryClient = new QueryClient({
    defaultOptions: {
      mutations: {
        onError: handleApiError,
      },
    },
  });

  return (
    <TranslationsProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <Router>
            <AppRoutes />
          </Router>
        </QueryClientProvider>
      </ThemeProvider>
    </TranslationsProvider>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID || '',
})(App);
